import { useState } from 'react';

export default function TestimonialSection() {
  const testimonials = [
    {
      name: '陳小姐',
      project: '台南｜30年老屋全室改造',
      rating: 5.0,
      content: '整個空間變得非常舒適，施工過程也很安心。GELi 閣立團隊非常專業，從設計到施工都很細心，讓我們的老屋煥然一新。特別是浴室改造的部分，防水工程做得很扎實，現在使用起來非常放心。',
      image: 'https://public.readdy.ai/ai/img_res/024abd142fb9e4092cbcda954e26d192.jpg',
    },
    {
      name: '林先生',
      project: '高雄｜小坪數浴室改造',
      rating: 5.0,
      content: '浴室改造的效果超乎預期，原本老舊的浴室現在變得像飯店一樣舒適。施工團隊很準時，工地也保持得很乾淨，讓我們在施工期間也能安心居住。價格透明合理，非常推薦！',
      image: 'https://readdy.ai/api/search-image?query=satisfied%20taiwanese%20male%20homeowner%20in%20modern%20renovated%20bathroom%20professional%20portrait%20clean%20contemporary%20design%20white%20tiles%20glass%20shower%20bright%20lighting%20happy%20customer%20quality%20renovation%20work%20comfortable%20space%20elegant%20interior&width=400&height=500&seq=testimonial-002&orientation=portrait',
    },
    {
      name: '王太太',
      project: '台南｜出租套房裝修',
      rating: 5.0,
      content: '作為房東，最重視的就是效率和品質。GELi 閣立團隊在短時間內完成了三間套房的裝修，品質很好，租客都很滿意。從設計到軟裝都幫我處理好，省了很多時間和精力。',
      image: 'https://readdy.ai/api/search-image?query=professional%20taiwanese%20female%20property%20owner%20in%20modern%20rental%20apartment%20confident%20landlord%20clean%20minimalist%20interior%20bright%20space%20quality%20furnishing%20satisfied%20expression%20contemporary%20design%20comfortable%20living%20room%20natural%20lighting&width=400&height=500&seq=testimonial-003&orientation=portrait',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-primary mb-4 font-serif">
            屋主真實回饋
          </h2>
          <p className="text-base text-gray-600">每一個滿意的笑容，都是我們前進的動力</p>
        </div>

        <div className="relative">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              <div className="lg:col-span-2 relative h-96 lg:h-auto">
                <img
                  src={current.image}
                  alt={current.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="lg:col-span-3 p-12 flex flex-col justify-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#4A90C2]/10 text-[#1E4D7B] rounded-full text-sm font-medium mb-6 self-start">
                  <i className="ri-star-fill"></i>
                  <span className="font-bold">{current.rating}</span>
                </div>
                <blockquote className="text-2xl text-gray-800 leading-relaxed mb-8 font-serif">
                  「{current.content}」
                </blockquote>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-[#4A90C2]/20 flex items-center justify-center">
                    <i className="ri-user-line text-xl text-[#1E4D7B]"></i>
                  </div>
                  <div>
                    <p className="text-base font-bold text-gray-900">{current.name}</p>
                    <p className="text-sm text-gray-600">{current.project}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-8">
            <button
              onClick={handlePrev}
              className="w-12 h-12 rounded-lg border-2 border-gray-300 flex items-center justify-center text-gray-600 hover:border-primary hover:text-primary transition-colors cursor-pointer"
              aria-label="上一則評價"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              onClick={handleNext}
              className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center text-white hover:bg-primary/90 transition-colors cursor-pointer"
              aria-label="下一則評價"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}